var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 22.963V7.688L10 0 0 7.688v15.275h8.1v-8.81h3.833v8.81H20zm-2.133-2.177h-3.8v-8.811h-8.1v8.811H2.132V8.777L10 2.722l7.867 6.055v12.01z",
    fill: "currentColor"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjAgMjMiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0yMCAyMi45NjNWNy42ODgwN0wxMCAwTDAgNy42ODgwN1YyMi45NjNIOC4wOTkyVjE0LjE1M0gxMS45MzI4VjIyLjk2M0gyMFpNMTcuODY3MiAyMC43ODYySDE0LjA2NzJWMTEuOTc0Nkg1Ljk2NjRWMjAuNzg2MkgyLjEzMjhWOC43NzcyN0wxMCAyLjcyMjE4TDE3Ljg2NzIgOC43NzcyN1YyMC43ODYyWiIgZmlsbD0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPgo=";
export { SvgNewHome as ReactComponent };